export default __webpack_public_path__ + "static/media/MyCert.c7b267b7917e28096c2d0f093f6181b5.webp";